import {createElement, Component, PropTypes} from 'rlink-react';
import {Store} from 'rlink-flux';
import shopActions from 'rlink-shop/actions';

class ShopStore extends Store {
  constructor () {
    super();
    this.productIds = {};
  }

  getFullState () {

    return this.productIds;
  }

  getFullProductState (identifier) {
    if (identifier in this.productIds) {
      return this.productIds[identifier];
    }

    return {};
  }

  onDispatch (dispatch) {
    let payload = dispatch.payload;
    switch (dispatch.action) {
      case shopActions.PriceLoaded: {
        this.addProductToState(payload.identifier);
        let priceData = {
          normalPrice: payload.normalPrice,
        };

        if ('salePrice' in payload) {
          priceData.salePrice = payload.salePrice;
          priceData.savingsPercentage = 100 - Math.ceil((payload.salePrice.amount / payload.normalPrice.amount) * 100);
        }

        if ('productID' in payload) {
          this.productIds[payload.identifier].productData = {productID: payload.productID};
        }

        if ('disable' in payload) {
          this.productIds[payload.identifier].disable = payload.disable;
        }

        this.productIds[payload.identifier].priceData = priceData;
        this.notifyChanged();
        break;
      }
      case shopActions.ModalContentLoaded:
        this.addProductToState(payload.identifier);
        this.productIds[payload.identifier].purchaseModalContent = payload.content;

        this.notifyChanged();
        break;
      case shopActions.OpenModal: {
        this.addProductToState(payload.identifier);
        let openModalKey = `${payload.modal}Open`;
        this.productIds[payload.identifier][openModalKey] = true;

        this.notifyChanged();
        break;
      }
      case shopActions.CloseModal: {
        this.addProductToState(payload.identifier);
        let closeModalKey = `${payload.modal}Open`;
        this.productIds[payload.identifier][closeModalKey] = false;

        this.notifyChanged();
        break;
      }
    }
  }

  addProductToState (identifier) {
    if (!(identifier in this.productIds)) {
      this.productIds[identifier] = {};
    }
  }
}

export default new ShopStore();



// WEBPACK FOOTER //
// ./lib/rlink-shop/store.jsx